import IconButton from "components/Button/IconButton";
import { dataEmpty } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import Label from "components/LabelInput/Label";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";

const AgesSalesCntTable = ({ reportState }) => {
  const resultTableInst = new resultTable();
  const [totalCnt, setTotalCnt] = useState(0);

  useEffect(() => {
    const sum =
      reportState.pt_age_data.length > 0
        ? reportState.pt_age_data[0].age_type_1 +
          reportState.pt_age_data[0].age_type_2 +
          reportState.pt_age_data[0].age_type_3 +
          reportState.pt_age_data[0].age_type_4 +
          reportState.pt_age_data[0].age_type_5
        : 0;
    setTotalCnt(sum);
  }, [reportState]);

  return (
    <div>
      <div style={{ display: "flex", marginBottom: "0.5rem" }}>
        <IconButton type="border" />
        <Label labelText="연령대별 판매 수량" marginLeft="0.5rem" fontWeight="bold" />
      </div>
      <CustomTable
        columns_head={resultTableInst.columns_head}
        table_title={resultTableInst.table_title}
        rest_call={resultTableInst.get_data_from_rest}
        row_render={resultTableInst.create_table}
        rest_data={reportState.pt_age_data}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
        <TextField
          labelText="합계"
          labelWidth="3rem"
          textBoxWidth="10rem"
          textMarginRight="0rem"
          isNumber
          defaultValue={totalCnt.toLocaleString()}
          endAdornment={"건"}
          disabled
        />
      </div>
    </div>
  );
};
export default AgesSalesCntTable;

class resultTable {
  table_title = "";

  // constructor() {}

  create_table = (data, idx) => {
    console.log(data);
    return (
      <CustomRow style={{}} key={idx}>
        <CustomTableContents $bgColor="#dfebf3">판매 수량</CustomTableContents>
        <CustomTableContents $isNumber>{data.age_type_1}</CustomTableContents>
        <CustomTableContents $isNumber>{data.age_type_2}</CustomTableContents>
        <CustomTableContents $isNumber>{data.age_type_3}</CustomTableContents>
        <CustomTableContents $isNumber>{data.age_type_4}</CustomTableContents>
        <CustomTableContents $isNumber>{data.age_type_5}</CustomTableContents>
      </CustomRow>
    );
  };

  columns_head = [
    { title: "구분", width: "16%" },
    { title: "0~19세", width: "16%" },
    { title: "20~29세", width: "16%" },
    { title: "30~39세", width: "16%" },
    { title: "40~49세", width: "16%" },
    { title: "50세 이상", width: "16%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
